import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`sales`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`sales`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`sales`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`sales/` + id);
  return response;
};
